<template>
  <OnboardingLayout
    title="Location Selection"
    description="Join thousands of Arnergy users all over Africa who are enjoying uninterrupted power supply with our solar solution."
    @onButtonClick="submitForm"
    imageDescription="System ownership is transferred upon meeting all lease obligations"
    :imageUrl="require('@/assets/img/female-wave.gif')"
    :canContinue="!showCustomLoading && canContinue"
    :loading="showLoading"
  >
    <div class="summary-container">
      <div class="summary">
        <el-form
          ref="form"
          :rules="{
            customerRegion: [
              {
                required: true,
                message:
                  'Please select the closest installation address region',
                trigger: 'change',
              },
            ],
          }"
          :model="formData"
        >
          <div class="grid">
            <el-form-item label="Region" prop="customerRegion">
              <el-select
                v-model="formData.customerRegion"
                filterable
                placeholder="Select a region"
                @change="checkCanContinue"
              >
                <el-option
                  v-for="location in locations"
                  :key="location.key"
                  :label="location.value"
                  :value="location.key"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </OnboardingLayout>
</template>

<script>
import OnboardingLayout from "@/components/layouts/onboarding-layout.vue";
import fixedRateLocations from "@/data/fixed-rate-location.json";
import ippLocationsData from "@/data/ipp-location.json";
import locationsData from "@/data/location.json";
import OnboardingService from "@/services/onboarding.js";
import { Icon, Tooltip } from "ant-design-vue";
import { Form, FormItem } from "element-ui";
import { mapGetters } from "vuex";

export default {
  components: {
    OnboardingLayout,
    "el-form": Form,
    "el-form-item": FormItem,
    ATooltip: Tooltip,
    AIcon: Icon,
  },
  computed: {
    ...mapGetters(["getUserSession"]),
    isFixedRateLocation() {
      return fixedRateLocations.some(
        (location) => location.key === this.$store.state.onboardingCustomerState.customerRegion
      );
    },
  },
  created() {
    this.locations = locationsData;
    this.ippLocations = ippLocationsData;
    this.LVI_REGIONS = fixedRateLocations;
  },
  data() {
    return {
      locations: [],
      showLoading: false,
      // yearlyPayment: [],
      canContinue: false,
      addToWaitList: false,
      showCustomLoading: false,
      nextPageName: "OnboardIPP",
      formData: {
        customerRegion: "",
      },
      onboardingStateId: null,
      isExistingUser: false,
      LVI_LOCATIONS: ["lekki", "victoria_island", "ikoyi"],

    };
  },
  methods: {
    checkCanContinue() {
      const {
        customerRegion,
      } = this.formData;
      this.determineNextPage();
      if (
        customerRegion
      ) {
        this.canContinue = true;
      } else {
        this.canContinue = false;
      }
    },
    determineNextPage() {
      this.addToWaitList = !this.ippLocations.find(
        (x) => x.key == this.formData.customerRegion
      );
    },
    async updateDBData(payloadData) {
      const { referralname, customerRegion } = await this.getCurrentState();
      const cannotSeePricingModelOption =
       ( referralname &&
        (referralname.toLowerCase() !== "" || referralname.toLowerCase() !== "sunfi"))
        || customerRegion && (referralname === null && this.LVI_LOCATIONS.includes(customerRegion.toLowerCase()));

      try {
        this.showLoading = true;

        if (this.addToWaitList) {
          await OnboardingService.addToWaitList(); // add to waitlist
        }

        const HTTP = this.$httpUtils.FASTHTTP;
        const requestPayload = {
          currentPageName: "OnboardLocationSelection",
          customerRegion: payloadData.customerRegion,
        };
        if (cannotSeePricingModelOption) {
          requestPayload.pricingModel = "fixed";
          // pricingModel: this.isFixedRateLocation ? "fixed" : null,
        }
        else {
          requestPayload.pricingModel = null;
        }
        const response = await HTTP.patch("/onboardingstate/nextstate", requestPayload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
          },
        });

        localStorage.setItem("onboardingStateId", response.data.id);

        // Update store with customerRegion
        const onboardingCustomerState = this.$store.state.onboardingCustomerState;
        this.$store.commit("saveOnboardingCustomerState", {
          ...onboardingCustomerState,
          customerRegion: payloadData.customerRegion,
        });
        
        this.navTo(this.nextPageName);
      } catch (error) {
        console.error('Error in updateDBData:', error);
      } finally {
        this.showLoading = false;
      }
    },

    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.updateDBData({
            ...this.formData,
            // product_id: this.activePackage.id,
            customerRegion: this.formData.customerRegion,
            customer_id: this.$store.state.onboardingCustomerState.customerid,
          });
        } else {
          // Form validation failed
        }
      });
    },

    async getCurrentState() {
      const HTTP = this.$httpUtils.FASTHTTP;
      const url = "/onboardingstate/state";
      try {
        const response = await HTTP.get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
          },
        });
        console.log("response.data", response.data);
        return response.data;
      } catch (error) {
        console.log({ error });
      }
    },
  },

  
  async mounted() {
    // this.activePackage =
    //   this.$store.state.onboardingCustomerState.selectedProduct;
    // this.onboardingStateId = localStorage.getItem("onboardingStateId");
    const stateData = await this.getCurrentState();
    if (stateData) {
      const { referralname } = stateData;
      if (!referralname) {
        this.locations = this.locations;
      } else {
        this.locations = this.LVI_REGIONS;
      }
    }
    this.$nextTick(() => {
      if (this.$refs.form) {
        this.$refs.form.clearValidate();
      }
    });
  },

};
</script>

<style lang="scss" scoped>
h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

.downPayment {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}
.tenureMonth {
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}

.buildingType {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}

.address {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
    // font-weight: normal;
  }
}

.quantity label {
  font-size: 16px;
  color: #727272;
  // font-weight: normal;
}
.quantity input {
  width: 50px;
  border-radius: 6px;
  height: 30px;
  margin-left: 6px;
  border: 1px solid #d3d9dd;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
}

.summary-container {
  width: 100%;
  max-width: 527px;
}

.summary {
  // width: 55%;

  h2 {
    color: #0892d0;
    margin-bottom: 30px;
    font-weight: 700;
  }

  > div {
    width: 100%;
  }

  .summary-table {
    padding: 0px 28px;
    background: #fafafa;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 17px 0px;
      border-bottom: 1px dashed #e8e2e2;

      p {
        color: #000000;
        font-size: 16px;
      }

      p:last-child {
        text-align: left;
        width: 30%;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .bold-text p {
      font-weight: bold;
    }

    .tabbed {
      position: relative;
    }

    .tabbed p {
      margin-left: 55px;
    }

    .tabbed .arrows {
      position: absolute;
      bottom: 30px;
      left: 25px;
    }
  }

  .tenure-section {
    margin-bottom: 30px;

    h4 {
      color: #fe7a11;
      margin-bottom: 10px;
      font-weight: bold;
    }

    .tenure-bar {
      display: flex;
      justify-content: space-between;

      .point {
        text-align: center;
        position: relative;
        width: 15px;
        overflow-x: visible;
        cursor: pointer;

        &:first-child {
          cursor: text;
        }

        &:last-child {
          text-align: right;
        }

        p {
          color: #efefef;
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 2px;
          height: 20px;
        }

        div {
          width: 3px;
          height: 8px;
          border-radius: 2px;
          background: #efefef;
          display: inline-block;
        }

        div.active {
          background: #ace5ff;
        }

        p.marked {
          padding: 2px 8px;
          border-radius: 5px;
          background: #0892d0;
          width: 80px;
          margin-left: -32.5px;
        }

        div.marked {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #0892d0;
        }
      }
    }

    .base-line {
      background: #efefef;
      height: 5px;
      border-radius: 9px;
      margin-top: -14px;

      .blue-line {
        width: 82.5%;
        height: 5px;
        background: #ace5ff;
        border-radius: 9px;
      }
    }
  }
}

.cost-loading {
  display: grid;
  height: 100px;
  place-content: center;
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}

.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.fixed-rate-message {
  color: #0892d0;
  font-size: 14px;
  margin-top: 8px;
  padding: 8px;
  background-color: #e6f6ff;
  border-radius: 4px;
  margin-bottom: 15px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/location-selection/index.vue